import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Plus, Trash2 } from "lucide-react";
import AdminBlogLayout from "./AdminBlogLayout";
import { deleteBlog, listAdminBlogs } from "../../../services/blogService";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [error, setError] = useState("");

  const refresh = () => {
    setError("");
    listAdminBlogs().then(setBlogs).catch((err) => setError(err?.response?.data?.detail || "Could not load blogs."));
  };

  useEffect(() => { refresh(); }, []);

  const remove = async (blog) => {
    if (!window.confirm(`Delete "${blog.title}"?`)) return;
    await deleteBlog(blog.id);
    refresh();
  };

  return (
    <AdminBlogLayout
      title="Blog Management"
      action={<Link to="/admin/blog/add" className="bg-cynos-red px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-white inline-flex items-center gap-2"><Plus size={14} /> Add Blog</Link>}
    >
      {error && <div className="mb-6 border border-cynos-red/40 bg-cynos-red/10 p-4 font-mono text-xs uppercase tracking-[0.18em] text-red-200">{error}</div>}
      <div className="overflow-x-auto border border-white/10 bg-cynos-card" data-testid="admin-blog-list">
        <table className="w-full text-sm">
          <thead className="border-b border-white/10 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">
            <tr>
              <th className="p-4 text-left">Image</th>
              <th className="p-4 text-left">Title</th>
              <th className="p-4 text-left">Category</th>
              <th className="p-4 text-left">Status</th>
              <th className="p-4 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {blogs.length === 0 && <tr><td colSpan={5} className="p-8 text-center font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">No blogs yet</td></tr>}
            {blogs.map((blog) => (
              <tr key={blog.id} className="border-b border-white/5">
                <td className="p-4">{blog.image && <img src={blog.image} alt={blog.title} className="h-14 w-20 object-cover" />}</td>
                <td className="p-4">
                  <div className="font-bold uppercase">{blog.title}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-500">{blog.slug}</div>
                </td>
                <td className="p-4 font-mono text-xs uppercase">{blog.category || "N/A"}</td>
                <td className="p-4 font-mono text-xs uppercase">{blog.published ? "Published" : "Draft"}</td>
                <td className="p-4">
                  <div className="flex gap-2">
                    <Link to={`/admin/blog/edit/${blog.id}`} className="border border-white/20 p-2 hover:border-white"><Edit size={14} /></Link>
                    <button onClick={() => remove(blog)} className="border border-cynos-red/40 p-2 text-cynos-red hover:border-cynos-red"><Trash2 size={14} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminBlogLayout>
  );
};

export default BlogList;
